import { useCallback } from 'react'
import { updateWorkItem } from '../application/update-work-item'
import type { UpdateWorkItemInput } from '../domain/workflow'
import { workItems$ } from '../store'
import { workItems as workItemsPort, notify } from '../wiring'

const useUpdateWorkItem = () => {
	const update = useCallback(async (input: UpdateWorkItemInput) => {
		const updated = await updateWorkItem(workItemsPort, input, notify)
		if (updated) {
			workItems$.set(workItems$.get().map(w => (w.id === updated.id ? updated : w)))
		}
		return updated
	}, [])

	return { update }
}

export { useUpdateWorkItem }
